// extracted by mini-css-extract-plugin
export default {"HeroSection":"TopBanner_HeroSection__2ihDi"};